import React from 'react';
import Modal from '../../lib/ui/components/Modal';
import Button from '../../lib/ui/components/button/Button';
import Tooltip from '../../lib/ui/components/tooltip/Tooltip';
import { Heading4 } from '../../lib/ui/components/typography/Typography';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

export default function ConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    details,
    confirmButtonText,
    confirmButtonVariant = "danger",
    isLoading = false,
    confirmDisabled = false,
    confirmDisabledReason,
    loadingText = "Processing...",
    cancelButtonText = "Cancel",
    cancelButtonVariant = "secondary",
    onSecondaryAction,
    secondaryActionText,
    secondaryActionVariant = "danger",
    secondaryActionDisabled = false,
    secondaryActionDisabledReason,
    dismissible = true,
    dataCyConfirm,
    dataCyCancel,
    footerChildren,
}) {
    return (
        <ErrorBoundary
            title="Confirmation Modal Error"
            description="There was an error loading the confirmation modal."
            showRefreshButton={false}
        >
            <Modal
                show={isOpen}
                onClose={onClose}
                size="lg"
                placement="center"
                dismissible={dismissible}
                root={typeof document !== "undefined" ? document.body : undefined}
            >
                <div className="p-6 relative">
                    <div className="flex justify-between items-center mb-4">
                        <Heading4>{title}</Heading4>
                    </div>

                    <div className="mb-6">
                        {details && (
                            <div className="mb-4 text-small leading-[150%] font-normal text-gray-600">
                                {details}
                            </div>
                        )}
                    </div>

                    <div className="flex justify-between items-center gap-3">
                        {footerChildren && <div>{footerChildren}</div>}
                        <div className="flex flex-wrap justify-end gap-3 ml-auto">
                        <Button
                            variant={cancelButtonVariant}
                            onClick={onClose}
                            disabled={isLoading}
                            data-cy={dataCyCancel}
                        >
                            {cancelButtonText}
                        </Button>
                        {onSecondaryAction && secondaryActionText && (
                            <Tooltip
                                content={secondaryActionDisabledReason}
                                disabled={!secondaryActionDisabled || !secondaryActionDisabledReason}
                            >
                                <span className="inline-block">
                                    <Button
                                        variant={secondaryActionVariant}
                                        onClick={onSecondaryAction}
                                        disabled={isLoading || secondaryActionDisabled}
                                    >
                                        {secondaryActionText}
                                    </Button>
                                </span>
                            </Tooltip>
                        )}
                        <Tooltip
                            content={confirmDisabledReason}
                            disabled={!confirmDisabled || !confirmDisabledReason}
                        >
                            <span className="inline-block">
                        <Button
                            variant={confirmButtonVariant}
                            onClick={onConfirm}
                            disabled={isLoading || confirmDisabled}
                            data-cy={dataCyConfirm}
                        >
                            {isLoading ? loadingText : confirmButtonText}
                        </Button>
                            </span>
                        </Tooltip>
                        </div>
                    </div>
                </div>
            </Modal>
        </ErrorBoundary>
    );
}
